import { memo } from 'react';
import Pds08Locale from 'locale/en/pds08.json';

const ModalPDS08Benefits = () => (
  <>
    <div className='head'>
      <div className='title'>{Pds08Locale.page_title}</div>
      <span>Citations</span>
    </div>
    <div>
      <p>
        <sup>1</sup>{' '}
        <a
          href='https://www.nature.com/articles/s41390-022-02289-0'
          target='_blank'
          rel='noreferrer'
        >
          Study in children specified daily use over 12 weeks.
        </a>
      </p>
      <p>
        <sup>2</sup> Rome IV criterion for constipation includes less than 3
        spontaneous bowel movements per week.
      </p>
      <p>
        <sup>3</sup> Native, commensal bacteria found in the human gut
        microbiome that are linked to the maintenance and improvement of
        digestive and immune function.
      </p>
      <p>
        <sup>4</sup> The presence of <i>Bifidobacterium</i> increased
        significantly in the stool among children taking PDS-08® over 12 weeks
        in a placebo-controlled clinical trial.
      </p>
      <p>
        <sup>5</sup> The Simulator of the Human Intestinal Microbial Ecosystem
        (SHIME®) is the closest <i>in vitro</i> system developed to simulate
        digestion and the gut.
      </p>
    </div>
  </>
);

export default memo(ModalPDS08Benefits);
